{
	"updateAvailable": "تتوفر نسخة جديدة من التطبيق. هل ترغب في إعادة التحميل؟",
	"updateTitle": "تحديث جديد",
	"updateButton": "تحديث",
	"mainPage": "الصفحة الرئيسية",
	"home": "الرئيسية",
	"print": "طباعة",
	"buyer": "المشتري",
	"seller": "البائع",
	"submit": "إرسال",
	"search": "بحث",
	"newReq": "طلب جديد",
	"detail": "التفاصيل",
	"confirm": "تأكيد",
	"dragAndDrop": "اسحب وأفلت الملفات هنا للتحميل",
	"ton": "طن",
	"accepted": "مقبول",
	"pending": "قيد الانتظار",
	"complete": "مكتمل",
	"view": "عرض",
	"unknown": "غير معروف",
	"section": "القسم",
	"type": "النوع",
	"acceptanceDate": "تاريخ القبول",
	"ipAddress": "عنوان IP",
	"simpleAcceptance": "قبول بسيط",
	"signatureRequired": "التوقيع مطلوب",
	"errorLoadingData": "خطأ في تحميل البيانات",
	"SIDEBAR": {
		"DASHBOARD": "لوحة التحكم",
		"TRADE": "تداول",
		"InboundGoods": "واردات البضائع",
		"inventory": "المخزون",
		"PORTFOLIO": "المحفظة",
		"ORDERS": "سجل الطلبات",
		"StockWalletDetails": "سجل الرمز",
		"ALERTS": "التنبيهات",
		"ADMIN": "الإدارة",
		"profile": "الملف الشخصي",
		"userManagement": "إدارة المستخدمين",
		"legalUserManagement": "طلب كيان قانوني",
		"MoneyRequestManagement": "إدارة الطلبات المالية",
		"InboundGoodsRequest": "طلب تخزين",
		"baseInformation": "المعلومات الأساسية",
		"stockSymbol": "الرموز",
		"goodsCategory": "تصنيف البضائع",
		"releaseGoodsFromWarehousePriceConfig": "تكوين الصادرات",
		"goodsToWarehousingPriceConfig": "تكوين الواردات",
		"labAnalysisPriceConfig": "تكوين التحليل المخبري",
		"CHARGE_WALLET": "المحفظة",
		"LAB_REPORTS": "تقارير المختبر",
		"moneyWallet": "التقارير المالية",
		"trade": "التداولات",
		"orders": "الطلبات",
		"warehouse": "المستودع",
		"laboratory": "المختبر",
		"report": "التقارير",
		"goodsToWarehouse": "طلبات الدخول",
		"goodsReleaseList": "طلبات الخروج",
		"goodsCanceledList": "قائمة البضائع الملغاة",
		"stockWalletDetails": "سجل الرمز",
		"warehouseManagement": "إدارة مستودعي",
		"agreementTemp": "الاتفاقيات والعقود",
		"chat": "الرسائل",
		"elasticManagement": "إدارة البحث المرن"
	},
	"elasticManagement": {
		"syncTitle": "مزامنة البيانات",
		"syncDesc": "إعادة فهرسة جميع الإعلانات المنشورة في Elasticsearch",
		"syncBtn": "بدء المزامنة",
		"syncSuccess": "تم بدء المزامنة بنجاح",
		"syncError": "فشلت المزامنة",
		"deleteTitle": "حذف الفهرس",
		"deleteDesc": "مسح جميع بيانات فهرس Elasticsearch بالكامل",
		"deleteBtn": "حذف الفهرس",
		"deleteSuccess": "تم حذف الفهرس بنجاح",
		"deleteError": "فشل الحذف",
		"confirmMsg": "هل أنت متأكد من حذف فهرس Elasticsearch بالكامل؟",
		"confirmHeader": "تأكيد الحذف",
		"confirmAccept": "نعم، احذف",
		"confirmReject": "إلغاء"
	},
	"agreement": {
		"details": {
			"title": "الاتفاقية",
			"status": "الحالة"
		}
	},
	"report": {
		"moneyWallet": "التقارير المالية",
		"orders": "تقارير الطلبات",
		"trade": "تقارير التداول",
		"debtorCreditorDetails": "التفاصيل",
		"realTradeAmount": "تكلفة التداول (بدون رسوم)",
		"fees": "الرسوم",
		"vat": "ضريبة القيمة المضافة"
	},
	"DASHBOARD": {
		"STOCKS_TITLE": "الأسهم",
		"PORTFOLIO_TITLE": "المحفظة الاستثمارية",
		"CASH_BALANCE": "الرصيد النقدي:"
	},
	"TABLE": {
		"SYMBOL": "الرمز",
		"COMPANY": "اسم الشركة",
		"PRICE": "السعر",
		"CHANGE": "التغيير",
		"VOLUME": "الحجم",
		"SHARES": "العدد",
		"AVG_BUY": "متوسط الشراء"
	},
	"PORTFOLIO": {
		"TITLE": "المحفظة",
		"TOTAL_VALUE": "إجمالي قيمة المحفظة",
		"basedOnLastTradePrice": "بناءً على آخر سعر تداول",
		"HOLDINGS": "المقتنيات",
		"SYMBOL": "الرمز",
		"QTY": "الكمية",
		"CURRENT_PRICE": "السعر الحالي (ريال)",
		"VALUE": "القيمة الإجمالية (ريال)",
		"PNL": "الربح/الخسارة (ريال)",
		"CURRENCY": "ريال",
		"AVG_BUY_PRICE": "متوسط السعر (ريال)",
		"NEW": "جديد",
		"SINCE_LAST_VISIT": "منذ آخر زيارة",
		"CARD_2_TITLE": "رصيدي",
		"CARD_3_TITLE": "الرصيد المحجوز",
		"CARD_4_TITLE": "قيد الموافقة",
		"showOldStockWallet": "عرض الأصول القديمة",
		"empty": "محفظتك فارغة"
	},
	"LAB_ANALYSIS": {
		"ID": "المعرف",
		"BUNDLE_CODE": "رمز الحزمة",
		"LABORATORY_NAME": "اسم المختبر",
		"ANALYSIS_TYPE": "نوع التحليل",
		"STATUS": "الحالة",
		"RESULT": "النتيجة",
		"CREATED_AT": "تاريخ الإنشاء",
		"UPDATED_AT": "تاريخ التحديث"
	},
	"TRADE": {
		"TITLE": "التداولات",
		"BALANCE": "الرصيد",
		"POSITIONS": "مراكزك",
		"SYMBOL": "الرمز",
		"QUANTITY": "الكمية",
		"AVG_PRICE": "متوسط السعر",
		"NEW_ORDER": "طلب جديد",
		"BUY": "شراء",
		"SELL": "بيع",
		"QTY": "العدد",
		"LIMIT_PRICE": "سعر محدد",
		"PLACE_ORDER": "إرسال",
		"ORDERS": "سجل الطلبات",
		"ID": "المعرف",
		"SIDE": "الجانب",
		"PRICE": "السعر",
		"STATUS": "الحالة",
		"TIME": "الوقت",
		"FILLED": "منفذ",
		"OPEN": "مفتوح",
		"CANCELLED": "ملغي",
		"DIRECTION": "{{dir}}",
		"PARTIALLY_FILLED": "منفذ جزئياً"
	},
	"profile": {
		"title": "ملف المستخدم",
		"firstName": "الاسم الأول",
		"lastName": "اسم العائلة",
		"email": "البريد الإلكتروني",
		"phone": "رقم الهاتف",
		"language": "اللغة",
		"save": "حفظ التغييرات",
		"changeAvatar": "تغيير الصورة الرمزية",
		"currentPassword": "كلمة المرور الحالية",
		"newPassword": "كلمة المرور الجديدة",
		"confirmPassword": "تأكيد كلمة المرور",
		"changePasswordBtn": "تغيير كلمة المرور",
		"required": "هذا الحقل مطلوب",
		"passwordMinLength": "يجب أن تتكون كلمة المرور من 6 أحرف على الأقل",
		"passwordMismatch": "كلمات المرور غير متطابقة",
		"infoTab": "معلومات المستخدم",
		"activeSessions": "الجلسات النشطة",
		"passwordTab": "تغيير كلمة المرور",
		"defaultReferral": "رمز الدعوة الافتراضي",
		"shareReferralLink": "مشاركة رابط الدعوة",
		"copy": "نسخ",
		"registerInvitationCode": "تسجيل رمز الدعوة",
		"invitationCode": "أدخل رمز الدعوة",
		"sending": "جاري الإرسال",
		"alreadyRegistered": "لقد قمت بالتسجيل بالفعل.",
		"benefitTitle": "لقد قمت بالتسجيل بالفعل.",
		"getRewardTitle": "كيفية الحصول على المكافآت",
		"invited": "المستخدمون المدعوون",
		"shareText": "مرحباً! استخدم هذا الرابط للتسجيل في الموقع. إنها منصة ممتازة وآمنة لتداول المعادن غير الحديدية:",
		"tabs": {
			"info": "معلومات المستخدم",
			"password": "تغيير كلمة المرور",
			"activeSessions": "الجلسات النشطة",
			"referral": "رمز الدعوة"
		},
		"form": {
			"changeAvatar": "تغيير الصورة الرمزية",
			"username": "اسم المستخدم",
			"email": "البريد الإلكتروني",
			"firstName": "الاسم الأول",
			"lastName": "اسم العائلة",
			"identity": "الرقم الوطني",
			"identityRequired": "الرقم الوطني مطلوب.",
			"phoneNumber": "رقم الهاتف",
			"edit": "تعديل"
		},
		"phoneDialog": {
			"title": "التحقق من رقم الهاتف",
			"enterNewPhone": "أدخل رقم هاتفك المحمول الجديد.",
			"send": "إرسال",
			"resend": "إعادة إرسال الرمز!",
			"enterOTP": "أدخل الرمز المرسل.",
			"confirm": "تأكيد"
		},
		"common": {
			"acceptanceDate": "تاريخ القبول",
			"ipAddress": "عنوان IP",
			"complete": "موقع",
			"view": "عرض",
			"confirmDelete": "هل أنت متأكد أنك تريد الحذف؟",
			"confirm": "تأكيد",
			"cancel": "إلغاء"
		},
		"termsAndAgreements": "الشروط والاتفاقيات",
		"terms": "العقود",
		"agreements": "الاتفاقيات",
		"noAgreementsFound": "لم يتم العثور على اتفاقيات"
	},
	"order": {
		"title": "طلباتي",
		"newOrder": "طلب جديد",
		"loading": "جاري تحميل الطلبات...",
		"error": "خطأ في تحميل الطلبات",
		"id": "رقم الطلب",
		"date": "التاريخ",
		"statusHeader": "الحالة",
		"total": "الإجمالي (ريال)",
		"empty": "لم تقم بتقديم أي طلبات بعد",
		"selectedItemsLabel": "نوع الحالة المحدد",
		"selectedOrdersTypeLabel": "نوع الطلب المحدد",
		"fee": "الحد الأقصى للرسوم",
		"priceWithFee": "السعر الإجمالي شامل الرسوم",
		"amountYouWillReceive": "إجمالي المبلغ المستلم شامل الرسوم",
		"statusMap": {
			"pending": "قيد الانتظار",
			"shipped": "تم الشحن",
			"delivered": "تم التوصيل",
			"cancelled": "ملغي",
			"NEW": "في قائمة الانتظار",
			"PARTIALLY_FILLED": "منفذ جزئياً",
			"CANCELED": "ملغي",
			"CANCELED_SELF_TRADE": "رفض التداول الذاتي",
			"FILLED": "مكتمل",
			"REJECTED": "مرفوض",
			"EXPIRED": "منتهي الصلاحية",
			"PARTIALLY_CANCELED": "ملغي (منفذ جزئياً)",
			"CANCELED_INSUFFICIENT_FUNDS": "ملغي (رصيد غير كافٍ)"
		},
		"header": {
			"index": "#",
			"orderType": "الطلب",
			"symbol": "الرمز",
			"date": "الوقت",
			"status": "الحالة",
			"price": "السعر (ريال)",
			"total": "المبلغ (ريال)",
			"quantity": "العدد",
			"fill_quantity": "الكمية المنفذة",
			"orderer": "مقدم الطلب"
		},
		"action": {
			"delete": "إلغاء",
			"deleteConfirmMsg": "هل أنت متأكد أنك تريد إلغاء طلبك؟",
			"confirm": "تأكيد",
			"cancel": "رجوع"
		},
		"confirmOrder": {
			"header": "تأكيد الطلب",
			"content": "هل أنت متأكد من تفاصيل طلبك؟",
			"marketOrderWarning": "ملاحظة: وفقاً للاتفاقية (سيتم تنفيذها)، في طلب السوق (Market)، قد يتم تنفيذ تداولك بأي سعر متاح في سجل الطلبات، وتقع المسؤولية كاملة عليك.",
			"confirm": "تأكيد وإرسال الطلب",
			"cancel": "إلغاء"
		}
	},
	"orderBook": {
		"count": "العدد",
		"quantity": "الحجم",
		"price": "السعر",
		"labelBuy": "طلبات الشراء",
		"labelSell": "طلبات البيع",
		"totalQuantity": "إجمالي الحجم",
		"buyTotalQuantity": "حجم الشراء",
		"sellTotalQuantity": "حجم البيع",
		"selectPrice": "انقر لتحديد السعر"
	},
	"goodsCategory": {
		"title": "فئات البضائع وفئاتها الفرعية",
		"addNewCategory": "إضافة فئة جديدة",
		"name": "الاسم",
		"actions": "الإجراءات",
		"edit": "تعديل",
		"delete": "حذف",
		"addSub": "إضافة فئة فرعية",
		"addCategory": "إضافة فئة",
		"cancel": "إلغاء",
		"save": "حفظ",
		"subCategoryDetails": "تفاصيل الفئة الفرعية"
	},
	"goodsToWarehousing": {
		"title": "تكوين سعر المستودع",
		"addConfig": "إضافة تكوين جديد",
		"stockSymbol": "رمز السهم",
		"price": "السعر",
		"startDate": "تاريخ البدء",
		"endDate": "تاريخ الانتهاء",
		"isActive": "نشط",
		"action": "الإجراءات",
		"edit": "تعديل",
		"delete": "حذف",
		"addConfigTitle": "إضافة تكوين سعر المستودع",
		"stockSymbolName": "اسم الرمز (النوع)",
		"priceLabel": "السعر",
		"isConfigActive": "هل التكوين نشط؟",
		"cancel": "إلغاء",
		"save": "حفظ",
		"validation": {
			"quantityRequired": "الكمية مطلوبة",
			"quantityMin": "الحد الأدنى يجب أن يكون 1"
		}
	},
	"labAnalysis": {
		"weightStatus": "الوزن",
		"bundleWeight": "وزن الحزمة",
		"bundleLabel": "ملصق الحزمة",
		"warehouseUnitTitle": "الوحدة",
		"converted": "مرمز",
		"not_converted": "غير مرمز",
		"title": "تكوين التحليل المخبري",
		"addConfig": "إضافة تكوين",
		"stockSymbol": "الرمز",
		"price": "السعر",
		"startDate": "تاريخ البدء",
		"endDate": "تاريخ الانتهاء",
		"isActive": "نشط",
		"action": "الإجراءات",
		"edit": "تعديل",
		"delete": "حذف",
		"addConfigTitle": "إضافة تكوين التحليل المخبري",
		"stockSymbolName": "اسم الرمز",
		"priceLabel": "السعر",
		"labExpertUser": "خبير المختبر",
		"approvedStockSymbol": "الرمز المعتمد",
		"stockSymbolOwnerSelfDeclaration": "الرمز المصرح به من المالك",
		"approved_true": "معتمد",
		"approved_false": "غير معتمد",
		"isConfigActive": "التكوين نشط",
		"cancel": "إلغاء",
		"save": "حفظ",
		"editTitle": "تعديل التحليل المخبري",
		"addTitle": "تسجيل التحليل المخبري",
		"analysisDate": "تاريخ التحليل",
		"analysisReport": "تقرير التحليل",
		"approved": "معتمد",
		"approvedQuantity": "الكمية المعتمدة",
		"selectStockSymbol": "اختر الرمز",
		"uploadReportFile": "تحميل ملف التقرير",
		"setUnit": "تخصيص وحدة",
		"result": {
			"title": "نتائج التحليل المخبري",
			"analysisDate": "تاريخ التحليل",
			"result": "النتيجة",
			"expertName": "اسم الخبير",
			"comments": "ملاحظات",
			"confirm": "تأكيد وترميز",
			"cancel": "إلغاء"
		},
		"error": "حدث خطأ ما",
		"validation": {
			"quantityRequired": "الكمية مطلوبة",
			"quantityMin": "يجب أن تكون الكمية أكبر من صفر",
			"analysisDateRequired": "تاريخ التحليل مطلوب",
			"stockSymbolRequired": "اختيار الرمز مطلوب",
			"analysisReportRequired": "تقرير التحليل مطلوب"
		},
		"status": {
			"PENDING": "قيد التحديد",
			"CONVERTED": "مرمز",
			"CANCELED": "ملغي"
		}
	},
	"releaseGoods": {
		"title": "تكوين سعر خروج البضائع",
		"addConfig": "إضافة تكوين جديد",
		"stockSymbol": "رمز السهم",
		"price": "السعر",
		"setDeliverTime": "تعيين وقت التسليم",
		"startDelivering": "بدء التحميل",
		"assignBundleNumber": "إدخال الحزم المخصصة",
		"delivered": "تم التسليم",
		"setDeliver": "تغيير الحالة إلى تم التسليم",
		"startDate": "تاريخ البدء",
		"endDate": "تاريخ الانتهاء",
		"isActive": "نشط",
		"action": "الإجراءات",
		"edit": "تعديل",
		"delete": "حذف",
		"addConfigTitle": "إضافة تكوين سعر الخروج",
		"stockSymbolName": "اسم الرمز (النوع)",
		"priceLabel": "السعر",
		"isConfigActive": "هل التكوين نشط؟",
		"cancel": "إلغاء",
		"save": "حفظ",
		"warehousemanFullName": "أمين المستودع",
		"bundlePlacement": "موقع الحزمة",
		"warehouseName": "المستودع",
		"validation": {
			"quantityRequired": "الكمية مطلوبة",
			"quantityMin": "الحد الأدنى يجب أن يكون 1"
		},
		"status": {
			"REQ_RELEASE": "تم طلب الإفراج",
			"ASSIGNED_DELIVER_TIME": "تم تعيين وقت الخروج",
			"LOADING_IN_WAREHOUSE": "جاري التحميل في المستودع",
			"RELEASE_CANCELED": "ملغي",
			"DELIVERED": "تم الخروج"
		}
	},
	"stockSymbolAdd": {
		"nameLabel": "الاسم",
		"nameRequired": "اسم الشركة مطلوب",
		"commentLabel": "ملاحظات",
		"faUnitLabel": "وحدة القياس (فارسي)",
		"enUnitLabel": "وحدة القياس (إنجليزي)",
		"minimumWeight": "الحد الأدنى للوزن المسموح به",
		"updateButton": "تحديث",
		"saveButton": "حفظ"
	},
	"stockSymbol": {
		"list": {
			"title": "رموز الأسهم",
			"add": "إضافة رمز سهم",
			"loading": "جاري التحميل...",
			"error": "خطأ في تحميل البيانات.",
			"header": {
				"index": "#",
				"name": "الاسم",
				"comment": "الوصف",
				"faUnit": "الوحدة الفارسية",
				"enUnit": "الوحدة الإنجليزية",
				"status": "الحالة"
			},
			"status": {
				"ACTIVE": "نشط (قابل للتداول)",
				"TRADE_STOP": "متوقف",
				"TRADE_STOP_HIDE": "متوقف (مخفي)"
			}
		}
	},
	"wallet": {
		"charge": "إيداع",
		"moneyRequest": "سحب",
		"moneyWalletPayById": "إيداع عبر المعرف",
		"myBalance": "رصيدي",
		"yourBalance": "رصيدك",
		"yourStockBalance": "رصيد أصولك",
		"insufficientFunds": "رصيد غير كافٍ.",
		"insufficientStock": "أصول غير كافية.",
		"loadStockBalanceFailed": "خطأ في تحميل الرصيد",
		"loadingData": "جاري تحميل بيانات السوق",
		"loadingStockBalance": "جاري تحميل رصيد أصولك",
		"loadDataFailed": "خطأ في تحميل الرصيد",
		"paginatorReport": "عرض {first} إلى {last} من {totalRecords} سجل",
		"LaboratoryFee": "رسوم المختبر",
		"StorageCost": "تكلفة التخزين",
		"TotalCost": "التكلفة الإجمالية",
		"addCard": "إضافة بطاقة",
		"description": "الوصف",
		"statusSelect": "الحالة المحددة",
		"yourCards": "بطاقاتك",
		"selectCardPLZ": "يرجى اختيار بطاقتك",
		"status": {
			"transaction": {
				"CREDIT": "زيادة رصيد",
				"CHARGE_ONLINE": "شحن عبر الإنترنت",
				"CHARGE_BANK_RECEIPT": "شحن عبر إيصال بنكي",
				"REVERSE_BY_ADMIN": "استرداد أموال",
				"MONEY_REQUEST": "طلب سحب",
				"MONEY_REQUEST_FEE": "رسوم السحب",
				"BUY_STOCK": "شراء سهم",
				"SELL_STOCK": "بيع سهم",
				"BUY_STOCK_FEE": "رسوم الشراء",
				"SELL_STOCK_FEE": "رسوم البيع",
				"GOODS_TO_WAREHOUSE_FEE": "رسوم التخزين",
				"GOODS_ANALYSIS_FEE": "رسوم التحليل المخبري",
				"RELEASE_FROM_WAREHOUSE": "رسوم الخروج",
				"RELEASE_FROM_WAREHOUSE_FEE": "رسوم نظام الخروج",
				"REFERRAL": "مكافأة الدعوة"
			},
			"payment": {
				"ACCEPTED": "مقبول",
				"BLOCKED": "محظور",
				"REJECTED": "مرفوض",
				"WAITING": "قيد الانتظار",
				"WAITING_BANK": "بانتظار البنك",
				"WAITING_FOR_ADMIN": "بانتظار الإدارة"
			}
		},
		"header": {
			"index": "#",
			"amount": "المبلغ الإجمالي (ريال)",
			"date": "التاريخ",
			"transactionType": "نوع المعاملة",
			"status": "الحالة",
			"user": "الشخص",
			"resNum": "معرف الإيداع"
		},
		"chargeModal": {
			"title": "شحن المحفظة",
			"amountLabel": "المبلغ:",
			"cancel": "إلغاء",
			"save": "حفظ"
		},
		"callback": {
			"verifying": "جاري التحقق من المعاملة، يرجى الانتظار...",
			"successTitle": "تم الدفع بنجاح",
			"successMessage": "تم شحن محفظتك بنجاح.",
			"backToWallet": "العودة إلى المحفظة",
			"failedTitle": "فشل الدفع",
			"userCancelled": "تم إلغاء المعاملة من قبلك أو واجهت خطأ. إذا تم خصم أموال، فسيتم إعادتها خلال 30 دقيقة إلى 72 ساعة.",
			"serverError": "خطأ في الخادم أثناء التحقق من المعاملة.",
			"retry": "إعادة المحاولة"
		}
	},
	"inboundGoodsRequest": {
		"title": "طلب دخول بضائع",
		"quantityInfo": "معلومات الكمية",
		"stockSymbolName": "رمز السهم",
		"initialQuantity": "الكمية الأولية",
		"bundleCount": "عدد الحزم",
		"bundleWeight": "وزن الحزمة (كجم)",
		"driverInfo": "معلومات السائق",
		"driverName": "اسم السائق",
		"driverMobile": "رقم جوال السائق",
		"driverCar": "سيارة السائق",
		"licensePlate": "لوحة الترخيص",
		"deliveryComments": "ملاحظات التسليم",
		"submit": "إرسال الطلب",
		"reset": "إعادة تعيين",
		"validation": {
			"quantityRequired": "الكمية مطلوبة",
			"quantityMin": "الحد الأدنى يجب أن يكون 1",
			"bundleCountRequired": "عدد الحزم مطلوب",
			"bundleWeightRequired": "وزن الحزمة مطلوب",
			"bundleWeightMin": "يجب أن يكون أكبر من 0",
			"driverNameRequired": "اسم السائق مطلوب",
			"mobileRequired": "رقم الجوال مطلوب",
			"mobilePattern": "يرجى إدخال رقم جوال صحيح",
			"carInfoRequired": "معلومات السيارة مطلوبة",
			"licensePlateRequired": "لوحة الترخيص مطلوبة"
		}
	},
	"orderForm": {
		"stockSymbol": "الرمز",
		"selectStockPrompt": "اختر رمزاً.",
		"orderType": "نوع الطلب",
		"transactionType": "نوع المعاملة",
		"trade_list": "قائمة التداول",
		"noTradesFound": "لم يتم العثور على تداولات",
		"buy": "شراء",
		"sell": "بيع",
		"quantity": "العدد",
		"price": "السعر",
		"submit": "إرسال",
		"paste": "لصق",
		"sending": "جاري الإرسال...",
		"LIMIT": "محدد",
		"limit_info": "يتم تنفيذ الطلب بالسعر الذي تحدده أو بسعر أفضل. تعتمد سرعة التنفيذ على السعر المحدد.",
		"MARKET": "سوق",
		"market_info": "يتم تنفيذ الطلب فوراً بأفضل سعر في السوق. قد يختلف السعر النهائي قليلاً بسبب التقلبات.",
		"marketOrderPriceNotice": "أفضل سعر تلقائياً",
		"validation": {
			"quantityRequired": "الكمية مطلوبة",
			"quantityMin": "الكمية يجب أن تكون 1 على الأقل",
			"priceRequired": "السعر مطلوب",
			"priceMin": "يجب أن يكون السعر موجباً"
		},
		"orderPlacedSuccessfully": "تم تقديم الطلب بنجاح!",
		"orderFailed": "فشل تقديم الطلب. يرجى المحاولة مرة أخرى.",
		"readyToExecute": "جاهز للتنفيذ",
		"notReadyToExecute": "بانتظار شروط التنفيذ",
		"insufficientFunds": "رصيد غير كافٍ",
		"insufficientStock": "أصول غير كافية",
		"quickActions": "إجراءات سريعة",
		"quickPresets": "إعدادات مسبقة سريعة",
		"priceShortcuts": "اختصارات الأسعار",
		"bestBid": "أفضل عرض شراء",
		"bestAsk": "أفضل عرض بيع",
		"lastPrice": "آخر سعر",
		"marketPrice": "سعر السوق",
		"orderPreview": "معاينة الطلب",
		"previewOrder": "معاينة الطلب",
		"orderSummary": "ملخص الطلب",
		"stock": "السهم",
		"orderTypePreview": "نوع الطلب",
		"quantityPreview": "الكمية",
		"pricePreview": "السعر",
		"grossAmount": "المبلغ الإجمالي",
		"feeAmount": "الرسوم",
		"netAmount": "المبلغ الصافي",
		"currentMarketPrice": "سعر السوق الحالي",
		"priceImpact": "تأثير السعر",
		"executionProbability": "احتمالية التنفيذ",
		"estimatedExecutionTime": "وقت التنفيذ المقدر",
		"high": "مرتفع",
		"medium": "متوسط",
		"low": "منخفض",
		"immediate": "فوري",
		"confirmAndExecute": "تأكيد وتنفيذ",
		"editOrder": "تعديل الطلب",
		"invalidOrder": "طلب غير صالح",
		"pleaseFillRequiredFields": "يرجى تعبئة جميع الحقول المطلوبة",
		"simulationNote": "هذه محاكاة بناءً على ظروف السوق الحالية. قد يختلف التنفيذ الفعلي.",
		"priceImpactNote": "يظهر تأثير السعر كيف قد يؤثر طلبك على سعر السوق.",
		"executionProbabilityNote": "بناءً على عمق السوق الحالي ومعلمات طلبك.",
		"quickPresetApplied": "تم تطبيق الإعداد المسبق السريع",
		"quickPresetAppliedDetail": "تم تطبيق الإعداد {{preset}}",
		"switchedToBuy": "تم التحويل إلى شراء",
		"switchedToSell": "تم التحويل إلى بيع",
		"marketOrderSelected": "تم اختيار طلب السوق",
		"limitOrderSelected": "تم اختيار طلب محدد",
		"marketAnalysis": "تحليل السوق",
		"seconds": "ثواني",
		"minutes": "دقائق",
		"hoursUncertain": "ساعات/غير مؤكد",
		"market": "سوق",
		"bid": "عرض شراء",
		"ask": "عرض بيع",
		"last": "آخر",
		"useMarketPrice": "استخدام سعر السوق",
		"current": "الحالي"
	},
	"login": {
		"title": "تسجيل الدخول",
		"username": "اسم المستخدم",
		"password": "كلمة المرور",
		"submit": "دخول"
	},
	"landing": {
		"title": "مرحباً بكم في سوق تادا للمعادن",
		"subtitle": "يرجى تسجيل الدخول للوصول إلى لوحة التحكم",
		"login": "دخول",
		"panel": "لوحة المستخدم",
		"logout": "تسجيل الخروج",
		"aboutTitle": "عن النظام",
		"aboutText": "يساعد هذا النظام الشركات والأفراد على إدارة التداولات والمخزون والامتثال في الوقت الفعلي.",
		"contactTitle": "اتصل بنا",
		"contactEmail": "بريد الدعم"
	},
	"roles": {
		"LEGAL": "كيان قانوني",
		"REAL": "شخص حقيقي",
		"TRADER": "متداول",
		"WHMAN": "مدير مستودع",
		"LAB": "مدير مختبر",
		"LABMAN": "مدير مختبر",
		"ADMIN": "مدير النظام",
		"USER": "مستخدم",
		"CLINIC_ADMIN": "مدير العيادة",
		"SALON_ADMIN": "مدير الصالون",
		"SUPER_ADMIN": "مدير عام",
		"TRAINEE_USER": "متدرب",
		"TRAINER_USER": "مدرب",
		"SELLER_USER": "بائع",
		"traderDesc": "تتبع تداولاتك ومحفظتك وطلباتك بشكل مباشر.",
		"warehouseDesc": "في تادابلس، يلعب أمين المستودع دوراً رئيسياً في سلسلة التداول، حيث يكون مسؤولاً عن استلام وتخزين وإدارة مخزون المعادن (خاصة الزنك). بعد التداول، يستلم أمين المستودع المعدن وفقاً للمواصفات، ويخزنه بشكل قياسي، ويسلمه للمشتري في الوقت المحدد. وهذا يضمن سلامة وصحة وأمان البضائع المتداولة.",
		"labDesc": "في تادابلس، يضمن المختبر جودة وصحة المعادن المتداولة. عند دخول المستودع، يقوم الخبراء بأخذ عينات وتحليل المواصفات الفنية والتركيب الكيميائي للمعدن. وهذا يؤكد ادعاء البائع ويضمن للمشترين الجودة.",
		"bannerDesc": "تادابلس هي منصة حديثة لتسهيل تداول المعادن بشفافية في السوق المحلية، بدءاً بالزنك. وهي تمكن من تقديم الطلبات عبر الإنترنت، ومطابقة العرض والطلب، وإدارة التداولات. تهدف تادابلس إلى إنشاء سوق شفاف وتنافسي وفعال وتخطط للتوسع في معادن أخرى قريباً.",
		"adminDesc": "إدارة المستخدمين والإعدادات والتحكم الكامل في النظام.",
		"LABORATORY": "المختبر",
		"more": "المزيد"
	},
	"signup": {
		"title": "إنشاء حساب",
		"name": "الاسم الكامل",
		"email": "البريد الإلكتروني",
		"password": "كلمة المرور",
		"submit": "تسجيل",
		"createAccountLink": "ليس لديك حساب؟ سجل الآن",
		"errors": {
			"nameRequired": "الاسم مطلوب",
			"emailInvalid": "بريد إلكتروني غير صالح",
			"passwordShort": "كلمة المرور يجب أن تكون 6 أحرف على الأقل"
		}
	},
	"adminDashboard": {
		"tradingVolume": "حجم التداول",
		"totalTraders": "إجمالي المتداولين",
		"warehouseStock": "مخزون المستودع",
		"labPending": "فحوصات مختبرية قيد الانتظار",
		"item": "عنصر",
		"quantity": "الكمية"
	},
	"footer": {
		"rights": "جميع الحقوق محفوظة.",
		"backToTop": "العودة للأعلى",
		"accessibility": "إمكانية الوصول",
		"contact us": "اتصل بنا",
		"customer service": "خدمة العملاء"
	},
	"app": {
		"title": "BEAUTYBOSS",
    "description": "أول مساعد ذكاء اصطناعي لصناعة التجميل"
  },
	"aboutUs": {
		"title": "من نحن",
		"description": "نحن منصة رائدة لتداول الأسهم توفر تحليلات في الوقت الفعلي وتجربة آمنة للمتداولين والمديرين والمستخدمين."
	},
	"contactUs": {
		"title": "اتصل بنا",
		"name": "الاسم",
		"email": "البريد الإلكتروني",
		"message": "الرسالة",
		"send": "إرسال الرسالة",
		"phoneNumber": "رقم الهاتف"
	},
	"laboratory": {
		"management": "إدارة المختبر",
		"title": "اسم المختبر",
		"item": "العنصر",
		"quantity": "الكمية",
		"evaluation": "التقييم",
		"symbol": "الرمز",
		"evaluate": "تقييم",
		"formTitle": "نموذج المختبر",
		"code": "رمز المختبر",
		"assignLabExpert": "تعيين خبير مختبر",
		"active": "نشط",
		"inactive": "غير نشط",
		"selectIsActive": "اختر حالة النشاط",
		"stockSymbols": "رموز الأسهم",
		"selectStockSymbols": "اختر رموز الأسهم",
		"expanded": {
			"labExperts": "الخبراء لـ {{lab}}: ",
			"emptyMessage": "لم يتم العثور على خبراء لـ {{lab}}"
		}
	},
	"warehouse": {
		"management": "إدارة المستودع",
		"detailsOfGoodsRelease": "تفاصيل خروج البضائع",
		"shed": {
			"title": "عنبر",
			"addTitle": "إضافة عنبر",
			"editTitle": "تعديل عنبر",
			"code": "الرمز"
		},
		"addShed": "بناء عنبر",
		"deleteShed": "حذف عنبر",
		"editShed": "تعديل عنبر",
		"corridor": {
			"title": "ممر",
			"addTitle": "بناء ممر",
			"editTitle": "تعديل ممر",
			"code": "الرمز"
		},
		"addCorridor": "بناء ممر",
		"label": "ملصق",
		"unitContent": "الحزم في الوحدة",
		"emptyUnitContent": "لا توجد بضائع في الوحدة",
		"selectedWeight": "الوزن المسحوب",
		"unit": {
			"title": "الوحدة",
			"code": "الرمز",
			"storageCapacity": "السعة",
			"currentOccupancy": "السعة المستخدمة",
			"totalArea": "المساحة الكلية",
			"usableArea": "المساحة القابلة للاستخدام",
			"addTitle": "بناء وحدة",
			"editTitle": "تعديل وحدة",
			"move": "نقل الوحدة"
		},
		"title": "اسم المستودع",
		"code": "رمز المستودع",
		"item": "العنصر",
		"volume": "الحجم",
		"owner": "المالك",
		"manage": "إدارة",
		"warehouseStatus": "حالة المستودع",
		"address": {
			"legend": "عنوان المستودع",
			"street": "الشارع",
			"city": "المدينة",
			"state": "المحافظة",
			"postalCode": "الرمز البريدي",
			"postalCodeWrong": "الرمز البريدي غير صحيح.",
			"country": "الدولة",
			"detail": "تفاصيل العنوان"
		},
		"totalArea": "المساحة الكلية",
		"usableArea": "المساحة القابلة للاستخدام",
		"status": "الحالة",
		"assignLabExpert": "تعيين خبير مختبر",
		"establishedDate": "تاريخ التأسيس",
		"lastInventoryDate": "تاريخ آخر جرد",
		"storageCapacity": "سعة التخزين",
		"currentOccupancy": "الإشغال الحالي",
		"goodsCategoryList": "فئات البضائع",
		"goodsSubCategoryList": "فئات البضائع الفرعية",
		"selectGoodsCategories": "اختر الفئات",
		"selectGoodsSubCategories": "اختر الفئات الفرعية",
		"selectWarehouseman": "اختر أمين المستودع",
		"validators": {
			"usableBiggerThanTotal": "يجب أن تكون المساحة الكلية أكبر من أو تساوي المساحة القابلة للاستخدام."
		},
		"expanded": {
			"warehouseman": "أمناء المستودع لـ {{warehouse}}: ",
			"emptyMessage": "لم يتم العثور على أمين مستودع لـ {{warehouse}}"
		},
		"statusList": {
			"ACTIVE": "نشط",
			"INACTIVE": "غير نشط",
			"UNDER_MAINTENANCE": "تحت الصيانة"
		},
		"outbound": {
			"selectedItemName": "اسم البضاعة المختارة للخروج من المستودع:",
			"maxExitVolume": "الحد الأقصى لحجم الخروج:",
			"ninetyFivePercentTooltip": "نظراً لهامش الخطأ في السبائك الموجودة، فإن الحد الأقصى لحجم الخروج هو 95% من أصولك.",
			"warehouseInventory": "مخزون المستودع:",
			"selectWarehouse": "اختيار المستودع",
			"noWarehouseFound": "لا يوجد مستودع يحتوي على البضاعة المطلوبة.",
			"dialogTitle": "نموذج خروج البضائع",
			"exitVolumeLabel": "حجم الخروج",
			"maxCapacityError": "يمكنك سحب بحد أقصى 95% من رصيدك.",
			"requiredCost": "التكلفة المطلوبة:",
			"insufficientBalance": "رصيد غير كافٍ",
			"quantityExceedsWarehouse": "الكمية المطلوبة تتجاوز مخزون المستودع.",
			"continue": "متابعة"
		}
	},
	"user": {
		"title": "إدارة المستخدمين",
		"userType": "حقيقي/قانوني",
		"identity": "الرقم الوطني",
		"createdDate": "تاريخ التسجيل",
		"firstName": "الاسم الأول",
		"lastName": "اسم العائلة",
		"username": "اسم المستخدم",
		"mobileNumber": "رقم الجوال",
		"address": "العنوان",
		"gender": "الجنس",
		"role": "الدور",
		"filterRole": "تصفية حسب الدور",
		"email": "البريد الإلكتروني",
		"all": "الكل",
		"selectRoles": "اختر الأدوار",
		"selectUserType": "اختيار نوع المستخدم",
		"shahkar": "تحقق شاهكار",
		"paginatorReport": "عرض {first} إلى {last} من {totalRecords} سجل",
		"addUser": "إضافة مستخدم جديد",
		"editUser": "تعديل المستخدم",
		"changeStatus": "تغيير الحالة",
		"blockConfirmTitle": "حظر المستخدم",
		"blockConfirmText": "هل أنت متأكد من حظر هذا المستخدم؟",
		"unblockConfirmTitle": "إلغاء حظر المستخدم",
		"unblockConfirmText": "هل أنت متأكد من إلغاء حظر هذا المستخدم؟",
		"blockSuccess": "تم حظر المستخدم بنجاح",
		"unblockSuccess": "تم إلغاء حظر المستخدم بنجاح",
		"header": {
			"index": "#",
			"identity": "الرقم الوطني",
			"firstName": "الاسم",
			"lastName": "اللقب",
			"mobileNumber": "الجوال",
			"role": "الدور",
			"actions": "الإجراءات"
		}
	},
	"genders": {
		"MALE": "ذكر",
		"FEMALE": "أنثى",
		"OTHER": "آخر"
	},
	"validation": {
		"nationalCode": "يجب أن يتكون الرقم الوطني من 10 أرقام",
		"mobile": "يجب أن يبدأ رقم الجوال بـ 09 ويتكون من 11 رقماً",
		"identity": "يرجى إدخال رقم وطني صحيح.",
		"mobileNumber": "يرجى إدخال رقم جوال صحيح.",
		"email": "يرجى إدخال عنوان بريد إلكتروني صحيح."
	},
	"add": "إضافة",
	"back": "رجوع",
	"update": "تحديث",
	"reset": "مسح",
	"edit": "تعديل",
	"delete": "حذف",
	"select": "اختيار",
	"actions": "الإجراءات",
	"save": "حفظ",
	"excel": "إكسل",
	"block": "حظر",
	"unblock": "إلغاء الحظر",
	"cancel": "إلغاء",
	"filters": {
		"username": "يرجى إدخال اسم المستخدم",
		"searchTerm": "أدخل اسم المستخدم",
		"startDate": "من تاريخ",
		"endDate": "إلى تاريخ",
		"fromAmount": "من مبلغ",
		"toAmount": "إلى مبلغ",
		"fromQuantity": "الكمية من",
		"toQuantity": "الكمية إلى",
		"birthDate": "تاريخ الميلاد",
		"status": "الحالة"
	},
	"activeDevices": {
		"expandAll": "توسيع الكل",
		"collapseAll": "طي الكل",
		"kick": "طرد",
		"header": {
			"index": "#",
			"device": "الجهاز",
			"os": "نظام التشغيل",
			"osVersion": "نسخة النظام",
			"current": "الحالي",
			"mobile": "جوال",
			"lastAccess": "آخر دخول"
		},
		"boolean": {
			"yes": "نعم",
			"no": "لا"
		},
		"expanded": {
			"sessionsFor": "جلسات لـ {{device}}",
			"header": {
				"index": "#",
				"ip": "IP",
				"browser": "المتصفح",
				"started": "بدأت",
				"lastAccess": "آخر دخول",
				"expires": "تنتهي"
			},
			"emptyMessage": "لا توجد جلسات لهذا الجهاز."
		}
	},
	"topbar": {
		"calendar": "التقويم",
		"messages": "الرسائل",
		"profile": "الملف الشخصي",
		"swichLang": "تغيير اللغة"
	},
	"messageService": {
		"add": {
			"success": "تم الإنشاء بنجاح",
			"error": "فشل الإنشاء"
		},
		"update": {
			"success": "تم التحديث بنجاح",
			"error": "فشل التحديث"
		},
		"delete": {
			"success": "تم الحذف بنجاح",
			"error": "فشل الحذف"
		}
	},
	"agreementTemplates": {
		"title": "قوالب الاتفاقيات",
		"addNew": "إضافة قالب جديد",
		"edit": "تعديل القالب",
		"delete": "حذف القالب",
		"loading": "جاري التحميل...",
		"empty": "لم يتم العثور على قوالب اتفاقيات",
		"form": {
			"title": "العنوان",
			"sectionKey": "مفتاح القسم",
			"agreementType": "نوع الاتفاقية",
			"content": "المحتوى",
			"active": "نشط",
			"newTemplate": "قالب اتفاقية جديد",
			"editTemplate": "تعديل القالب"
		},
		"agreementTypes": {
			"SIMPLE_ACCEPTANCE": "قبول بسيط",
			"SIGNATURE_REQUIRED": "توقيع مطلوب"
		},
		"validation": {
			"titleRequired": "العنوان مطلوب",
			"sectionKeyRequired": "مفتاح القسم مطلوب",
			"contentRequired": "المحتوى مطلوب"
		},
		"actions": {
			"save": "حفظ",
			"cancel": "إلغاء"
		},
		"messages": {
			"createSuccess": "تم إنشاء قالب الاتفاقية بنجاح",
			"createError": "فشل إنشاء قالب الاتفاقية",
			"updateSuccess": "تم تحديث قالب الاتفاقية بنجاح",
			"updateError": "فشل تحديث قالب الاتفاقية",
			"deleteSuccess": "تم حذف قالب الاتفاقية بنجاح",
			"deleteError": "فشل حذف قالب الاتفاقية",
			"deleteConfirm": "هل أنت متأكد أنك تريد حذف هذا القالب؟",
			"validationError": "يرجى تعبئة جميع الحقول المطلوبة",
			"loadError": "فشل تحميل قوالب الاتفاقيات"
		},
		"table": {
			"title": "العنوان",
			"sectionKey": "مفتاح القسم",
			"agreementType": "نوع الاتفاقية",
			"active": "نشط",
			"actions": "الإجراءات"
		}
	},
	"goodsToWarehouse": {
		"trackingNumber": "رقم التتبع",
		"owner": "المالك",
		"goodsSubCategory": "الفئة الفرعية",
		"warehouse": "المستودع",
		"warehouseman": "أمين المستودع",
		"initialQuantity": "الوزن الإجمالي",
		"remainedQuantity": "الوزن المتبقي",
		"bundleCount": "عدد الحزم",
		"bundleWeight": "وزن الحزمة",
		"status": "الحالة",
		"requestDate": "تاريخ الطلب",
		"receivedDate": "تاريخ الاستلام",
		"scheduledDateToDeliverInWarehouse": "تاريخ التسليم المجدول",
		"goodsToWarehousingPrice": "تكلفة التخزين",
		"labAnalysisPrice": "تكلفة التحليل المخبري",
		"driverName": "اسم السائق",
		"driverMobile": "جوال السائق",
		"driverCar": "سيارة السائق",
		"licensePlate": "لوحة الترخيص",
		"deliveringCommentsFromRequester": "ملاحظات مقدم الطلب",
		"deliveringCommentsFromWarehouseman": "ملاحظات أمين المستودع",
		"assignedLaboratory": "المختبر المعين",
		"approvedQuantity": "الكمية المعتمدة",
		"approveWeight": "تأكيد الوزن",
		"approveWeightConfirmation": "هل أنت متأكد أنك تريد تأكيد الوزن؟",
		"updateWeightSuccessMessage": "تم تأكيد الوزن بنجاح",
		"setWarehouse": "تخصيص مستودع",
		"assignLaboratory": "تعيين مختبر",
		"assignDeliveryTime": "تعيين وقت التسليم",
		"assignLabAnalysis": "تسجيل نتائج المختبر",
		"receivedInWarehouse": "وقت الاستلام في المستودع",
		"setWarehouseDialogHeader": "تخصيص مستودع",
		"assignDeliverTimeDialogHeader": "تعيين وقت التسليم",
		"receivedInWarehouseDialogHeader": "وقت الاستلام في المستودع",
		"labAnalysisResult": "عرض نتائج المختبر",
		"goodsBundleLabAnalysis": "تسجيل نتائج المختبر",
		"goodsBundleLabAnalysisResult": "نتائج المختبر",
		"seeGoodsBundleLabAnalysisResult": "عرض نتائج المختبر",
		"updateDriverInformation": "تعديل معلومات السائق",
		"delete": "حذف",
		"labAnalysisMismatch": "حل عدم التطابق",
		"assignUnitToBundle": "وزن الحزم",
		"statusList": {
			"NEW": "طلب جديد",
			"REQ_WAREHOUSED": "طلب تخزين",
			"ASSIGNED_DELIVER_TIME": "تم تعيين وقت التسليم",
			"DELIVERED_IN_WAREHOUSE": "بانتظار تأكيد الوزن",
			"APPROVED_WEIGHT": "تم تأكيد الوزن",
			"PENDING_ANALYSIS": "بانتظار التحليل",
			"LAB_ANALYSIS_RESULT_IS_READY": "نتيجة التحليل جاهزة",
			"CANCELED_WAREHOUSING": "تم إلغاء التخزين",
			"PARTIALLY_CANCELED": "ملغي جزئياً",
			"CONVERTED_TO_STOCKS": "تم التحويل إلى أسهم",
			"RESULT_MISMATCH": "عدم تطابق بين نتائج المختبر والرمز المصرح به"
		},
		"releaseFromShed": {
			"reqQuantity": "الكمية المطلوبة",
			"deliveredQuantity": "الكمية المسلمة"
		}
	},
	"cancelGoodsToWarehouse": {
		"releasedDate": "وقت الخروج من المستودع",
		"statusList": {
			"PENDING": "تسجيل أولي",
			"REQ_RELEASE": "طلب تخزين",
			"ASSIGNED_DELIVER_TIME": "تم تعيين الوقت",
			"LOADING_IN_WAREHOUSE": "جاري التحميل",
			"DELIVERED": "تم التسليم في المستودع"
		}
	},
	"canceledGoodsList": {
		"updateDriverInfo": "تحديث معلومات السائق"
	},
	"updateDriverInfo": {
		"submit": "تحديث معلومات السائق",
		"error": "خطأ",
		"errorMessage": "خطأ في تحديث معلومات السائق",
		"validationError": "خطأ في التحقق",
		"validationErrorMessage": "يرجى تعبئة جميع الحقول المطلوبة بشكل صحيح"
	},
	"stockDetails": {
		"loading": "جاري تحميل البيانات...",
		"error": "خطأ في استرجاع البيانات.",
		"empty": "لا توجد بيانات للعرض.",
		"currentPrice": "السعر الحالي",
		"dailyVolume": "الحجم اليومي",
		"dayHigh": "أعلى سعر يومي",
		"dayLow": "أدنى سعر يومي",
		"yearHigh": "أعلى سعر سنوي",
		"yearLow": "أدنى سعر سنوي"
	},
	"stockWalletDetails": {
		"title": "سجل الرمز",
		"loading": "جاري تحميل المعاملات...",
		"error": "خطأ في تحميل المعاملات",
		"empty": "لم يتم العثور على معاملات",
		"transactionType": "نوع المعاملة",
		"paymentStatus": "حالة الدفع",
		"amount": "المبلغ",
		"coefficient": "المعامل",
		"dateOfTransaction": "تاريخ المعاملة",
		"description": "الوصف",
		"traceCode": "رمز التتبع",
		"summary": {
			"totalBuy": "إجمالي الشراء",
			"totalSell": "إجمالي البيع",
			"totalFees": "إجمالي الرسوم",
			"pendingTransactions": "معاملات قيد الانتظار",
			"netBalance": "صافي الرصيد"
		},
		"transactionTypes": {
			"BUY": "شراء",
			"SELL": "بيع",
			"FEE": "رسوم",
			"GOODS_TO_WAREHOUSE": "دخول المستودع",
			"RELEASE_FROM_WAREHOUSE": "خروج المستودع"
		},
		"paymentStatuses": {
			"ACCEPTED": "مقبول",
			"BLOCKED": "محظور"
		},
		"filters": {
			"symbol": "الرمز",
			"transactionType": "نوع المعاملة",
			"paymentStatus": "حالة الدفع",
			"amountRange": "نطاق المبلغ",
			"search": "بحث",
			"fromAmount": "من مبلغ",
			"toAmount": "إلى مبلغ",
			"allTypes": "كل الأنواع",
			"allStatuses": "كل الحالات",
			"clearFilters": "مسح التصفيات",
			"applyFilters": "تطبيق التصفيات"
		},
		"timeline": {
			"today": "اليوم",
			"yesterday": "أمس",
			"daysAgo": "منذ {{count}} يوم",
			"hoursAgo": "منذ {{count}} ساعة",
			"minutesAgo": "منذ {{count}} دقيقة"
		},
		"loadMore": "عرض المزيد",
		"remaining": "المتبقي"
	},
	"ratioHelp": "يوضح هذا الرسم البياني توزيع الحجم في طلبات الشراء والبيع كنسبة مئوية.",
	"sendPhoto": "إرسال صورة",
	"tour": {
		"help": "مساعدة",
		"prevBtnTitle": "السابق",
		"nextBtnTitle": "التالي",
		"endBtnTitle": "إنهاء",
		"welcome_t": "دليل النظام",
		"welcome_c": "مرحباً بك. اتبع الخطوات معي لشرح ميزات النظام.",
		"order0_t": "طلب محدد",
		"order0_c": "يتم تنفيذ الطلب بالسعر الذي تحدده أو بسعر أفضل. تعتمد السرعة على السعر المحدد.",
		"order1_t": "طلب السوق",
		"order1_c": "يتم تنفيذ الطلب فوراً بأفضل سعر في السوق. قد يختلف السعر النهائي قليلاً بسبب التقلبات.",
		"ratioHelp_t": "مخطط توزيع الحجم",
		"ratioHelp_c": "يوضح هذا الرسم البياني توزيع الحجم في طلبات الشراء والبيع كنسبة مئوية.",
		"chartHelp_t": "مخطط السعر",
		"chartHelp_c": "استخدم هذا المخطط لعرض الأسعار وأحجام الشراء/البيع خلال فترات زمنية مختلفة."
	},
	"referralTimeLine": {
		"step1": "شارك رابطك الحصري مع الأصدقاء.",
		"step2": "يسجل أصدقاؤك في تاداماركت ويقومون بالتداول.",
		"step3": "بعد أول تداول، ستحصل أنت وأصدقاؤك على مكافآت.",
		"submitted": "تم إرسال رمز الدعوة بنجاح",
		"not_submitted": "لم يتم إرسال رمز الدعوة"
	},
	"CONNECTION": {
		"CONNECTED": "متصل",
		"ATTEMPTING": "جاري الاتصال...",
		"DISCONNECTED": "انقطع الاتصال",
		"NAME": "حالة الاتصال"
	},
	"cards": {
		"title": "إدارة البطاقات",
		"card": "البطاقة",
		"addNew": "إضافة بطاقة جديدة",
		"cardNumber": "رقم البطاقة",
		"bankName": "اسم البنك",
		"status": "الحالة",
		"default": "الافتراضي",
		"secondary": "ثانوي",
		"setDefault": "تعيين كافتراضي",
		"delete": "حذف",
		"addCard": "إضافة بطاقة",
		"noCardsFound": "لم يتم العثور على بطاقات",
		"confirmSetDefault": "هل أنت متأكد أنك تريد تعيين هذه البطاقة كافتراضية؟",
		"addCardDescription": "أضف بطاقة دفع جديدة لحسابك",
		"cardNumberPlaceholder": "أدخل رقم البطاقة المكون من 16 رقماً",
		"cardNumberRequired": "رقم البطاقة مطلوب ويجب أن يكون 16 رقماً",
		"invalidCard": "رقم البطاقة غير صالح.",
		"securityNotice": "تنبيه أمني",
		"securityNoticeDescription": "يتم تخزين بيانات بطاقتك بشكل مشفر وآمن. لا نقوم بتخزين رقم بطاقتك الكامل أبداً.",
		"defaultBank": "البنك",
		"actions": "الإجراءات"
	},
	"userProfileCompletion": {
		"title": "إكمال الملف الشخصي",
		"subtitle": "يرجى إكمال معلوماتك",
		"steps": {
			"basicInfo": "المعلومات الأساسية",
			"userType": "نوع المستخدم",
			"bankCardInfo": "معلومات البطاقة البنكية"
		},
		"basicInfoSection": {
			"title": "المعلومات الأساسية",
			"description": "إذا كانت المعلومات غير صحيحة، استخدم زر التعديل في نهاية كل حقل.",
			"birthDate": "تاريخ الميلاد",
			"mobile": "رقم الجوال",
			"nationalId": "الرقم الوطني",
			"continue": "متابعة"
		},
		"addCardSection": {
			"cardAdded": "تم إضافة البطاقة بنجاح"
		},
		"userTypeSection": {
			"title": "التحويل إلى حساب شركة",
			"description": "إذا كنت ترغب في التحويل إلى حساب قانوني (شركة)، انقر الزر أدناه.",
			"switchToLegal": "طلب التحويل إلى حساب شركة",
			"requestPending": "تم إرسال طلبك للتحويل إلى حساب شركة. يرجى انتظار موافقة الإدارة. لا يمكنك المتابعة حتى تتم الموافقة.",
			"requestSuccess": "تم إرسال طلبك للتحويل إلى حساب شركة بنجاح.",
			"requestError": "حدث خطأ أثناء إرسال طلبك."
		}
	},
	"dialogs": {
		"legal": {
			"title": "طلب التحويل لحساب شركة",
			"companyName": "اسم الشركة",
			"companyNationalId": "الرقم الوطني للشركة",
			"companyRegNum": "رقم التسجيل",
			"companyPostalCode": "الرمز البريدي للشركة",
			"companyAddress": "عنوان الشركة",
			"cancel": "إلغاء",
			"submit": "إرسال الطلب",
			"sending": "جاري الإرسال...",
			"economicCode": "الرمز الاقتصادي"
		},
		"legalUserStatus": {
			"title": "تغيير حالة المستخدم القانوني",
			"userLabel": "المستخدم",
			"statusLabel": "الحالة الجديدة",
			"statusPlaceholder": "اختر الحالة",
			"cancel": "إلغاء",
			"update": "تحديث الحالة",
			"updateSuccess": "تم تحديث حالة المستخدم بنجاح"
		},
		"phone": {
			"title": "تغيير رقم الجوال",
			"newPhoneLabel": "رقم الجوال الجديد",
			"placeholder": "09123456789",
			"sendOtp": "إرسال الرمز",
			"sendingOtp": "جاري الإرسال...",
			"otpLabel": "أدخل رمز التحقق",
			"verifyOtp": "تحقق من الرمز",
			"verifyingOtp": "جاري التحقق..."
		},
		"identity": {
			"title": "تغيير الرقم الوطني",
			"newIdentityLabel": "الرقم الوطني الجديد",
			"placeholder": "1234567890",
			"cancel": "إلغاء",
			"update": "تحديث",
			"updating": "جاري التحديث..."
		},
		"releaseGoodsFromWarehouse": {
			"select": "يرجى اختيار بضائعك للخروج أولاً"
		}
	},
	"approval-wait-list": {
		"title": "طلبات تغيير الدور",
		"loading": "جاري التحميل...",
		"empty": "لا توجد طلبات.",
		"messages": { "loadError": "فشل تحميل البيانات" },
		"form": { "name": "المستخدم", "role": "الدور المطلوب" },
		"filters": { "status": "الحالة", "role": "الدور" },
		"table": { "status": "الحالة", "date": "التاريخ", "actions": "إجراءات" },
		"details": {
			"title": "تفاصيل الطلب",
			"feedback": "ملاحظات المسؤول",
			"files": "المستندات المرفقة",
			"document": "وثيقة الهوية",
			"certificate": "الشهادة",
			"license": "الترخيص",
			"feedbackPlaceholder": "أدخل ملاحظات للمستخدم عند الحاجة...",
			"notReviewable": "هذا الطلب ليس قابلاً للمراجعة",
			"confirmApprove": "هل أنت متأكد من الموافقة وتعيين هذا الدور للمستخدم؟"
		},
		"actions": { "startReview": "بدء المراجعة", "requestEdit": "طلب تعديل", "reject": "رفض", "approve": "موافقة" },
		"statuses": {
			"draft": "مسودة", "submitted": "مُرسل", "under_review": "قيد المراجعة",
			"needs_edit": "يحتاج تعديل", "approved": "موافق عليه", "rejected": "مرفوض"
		},
		"roles": {
			"clinic_admin": "مدير العيادة", "salon_admin": "مدير الصالون",
			"trainer_user": "مدرّب", "trainee_user": "متدرب", "seller_user": "بائع"
		},
		"validation": { "feedbackRequired": "الملاحظات مطلوبة لهذا الإجراء." }
	},
	"requestRole": {
		"title": "طلب تغيير الدور",
		"subtitle": "اختر الدور المطلوب وقم بتحميل المستندات اللازمة.",
		"selectRole": "اختر الدور",
		"documents": "المستندات",
		"requiredDocs": "المستندات المطلوبة",
		"activeAccesses": "الصلاحيات النشطة بعد الموافقة",
		"uploadWarning": "لتقديم طلب التحقق، من الضروري تحميل جميع المستندات. إذا كانت المستندات غير مكتملة، لا يمكن تقديم الطلب.",
		"noDocsRequired": "لا توجد مستندات مطلوبة",
		"noAvailableRoles": "لديك حالياً طلب نشط لجميع الأدوار أو تمتلك بالفعل الأدوار المتاحة.",
		"selectSubType": "نوع المسجل",
		"additionalInfo": "معلومات إضافية",
		"documentsHint": "قم بتحميل جميع المستندات المطلوبة لدورك المختار.",
		"adminNote": "ملاحظة المسؤول",
		"needsEditTitle": "طلبك يحتاج إلى تعديلات",
		"needsEditHint": "يرجى إصلاح المشاكل المذكورة وإعادة الإرسال. لا يمكن تغيير الدور في هذه المرحلة.",
		"roleLocked": "لا يمكن تغيير الدور في هذه المرحلة.",
		"upload": "تحميل", "uploaded": "تم التحميل",
		"saveDraft": "حفظ المسودة", "submit": "إرسال للمراجعة",
		"edit": "تعديل",
		"noIdentity": "يرجى إكمال معلومات هويتك أولاً.",
		"goToProfile": "إكمال المعلومات",
		"myRequests": "طلباتي",
		"files": {
			"nationalId": "تحميل بطاقة الهوية الوطنية",
			"spaceSignPhoto": "تحميل صورة اللافتة أو مدخل المساحة",
			"spaceImages": "تحميل صور حقيقية للمساحة",
			"businessLicense": "تحميل رخصة العمل",
			"clinicLicense": "تحميل رخصة العيادة",
			"medicalCertificate": "تحميل شهادة النظام الطبي",
			"resume": "تحميل السيرة الذاتية / ملف الأعمال / شهادة الدورة",
			"courseSyllabus": "تحميل منهج الدورة",
			"schoolLicense": "تحميل رخصة المدرسة أو المعهد",
			"ownershipProof": "تحميل الفاتورة أو إثبات الملكية",
			"healthCertificate": "تحميل شهادة الصحة أو أصالة المنتج",
			"productImages": "تحميل صور حقيقية للمنتج",
			"realEstateLicense": "تحميل رخصة أو تصريح العقارات",
			"publicationPermit": "تحميل تصريح نشر الإعلان"
		},
		"statuses": {
			"draft": "بانتظار اكتمال المستندات",
			"submitted": "بانتظار المراجعة",
			"under_review": "قيد المراجعة",
			"needs_edit": "يحتاج تصحيح",
			"approved": "موافق عليه",
			"rejected": "مرفوض"
		},
		"roles": {
			"user": "مستخدم عادي",
			"beauty_artist": "فنان تجميل / متدرب",
			"salon_admin": "مدير صالون / مالك مساحة",
			"clinic_admin": "طبيب / مدير عيادة",
			"instructor": "مدرس / معهد",
			"trainer_user": "مدرس / معهد",
			"trainee_user": "فنان تجميل / متدرب",
			"seller_user": "بائع معدات أو مواد تجميل"
		},
		"subTypes": {
			"salonOwner": "مدير صالون / مالك مساحة",
			"realEstateExpert": "خبير عقارات",
			"student": "متدرب",
			"artist": "فنان تجميل",
			"teacher": "مدرس",
			"school": "معهد",
			"doctor": "طبيب",
			"clinicManager": "مدير عيادة",
			"equipment": "معدات",
			"material": "مواد استهلاكية"
		},
		"textFields": {
			"lineOfWork": "مجال التخصص",
			"medicalSystemNumber": "رقم النظام الطبي",
			"officeAddress": "عنوان محل العمل",
			"officeContactNumber": "رقم اتصال محل العمل",
			"productInfo": "معلومات المنتج (الرقم التسلسلي، الضمان، تاريخ الإنتاج والانتهاء)"
		},
		"accesses": {
			"user": {
				"viewAds": "مشاهدة الإعلانات",
				"searchFilter": "بحث، تصفية، مقارنة",
				"compare": "مقارنة الإعلانات",
				"saveInterests": "حفظ الاهتمامات",
				"viewCoursesProfiles": "مشاهدة الدورات والملفات الشخصية",
				"viewContactInfo": "مشاهدة معلومات الاتصال بالمعلن",
				"contactAdvertiser": "الاتصال بالمعلن وإرسال الرسائل"
			},
			"salonAdmin": {
				"registerSpaceAds": "تسجيل إعلانات تأجير المساحات",
				"manageAds": "إدارة وتحرير وحذف وتمديد الإعلانات",
				"viewMessages": "مشاهدة الرسائل",
				"viewStats": "مشاهدة إحصائيات الزيارة",
				"contact": "التواصل والحفظ",
				"payments": "المدفوعات"
			},
			"traineeUser": {
				"viewCompareAds": "مشاهدة ومقارنة الإعلانات",
				"viewContactInfo": "مشاهدة معلومات الاتصال",
				"sendMessages": "إرسال الرسائل",
				"viewCourses": "مشاهدة الدورات",
				"registerCompanion": "تسجيل طلب مرافق",
				"registerRentalAd": "تسجيل إعلان تأجير أو مرافق",
				"sellPersonalEquipment": "بيع المعدات الشخصية أو المستعملة",
				"registerAuction": "تسجيل إعلان مزاد للمعدات الشخصية",
				"manageAds": "إدارة إعلاناتك",
				"purchaseServices": "شراء سلم / فوري / خاص"
			},
			"trainerUser": {
				"registerCourses": "تسجيل دورات حضورية أو عبر الإنترنت أو مدمجة",
				"manageCourses": "إدارة وتحرير وحذف وتمديد الدورات",
				"viewStudentMessages": "مشاهدة رسائل وطلبات الطلاب",
				"viewStats": "مشاهدة إحصائيات الزيارة والتسجيل",
				"purchaseServices": "شراء إعلانات وسلم وفوري وخاص"
			},
			"clinicAdmin": {
				"registerSpaceAds": "تسجيل إعلان المساحة السريرية",
				"registerCooperationAds": "تسجيل إعلان تعاون تخصصي",
				"introduceServices": "تقديم الخدمات القابلة للعرض",
				"manageAds": "إدارة الإعلانات",
				"receiveMessages": "استلام الرسائل",
				"viewStats": "مشاهدة الإحصائيات",
				"purchasePromotions": "شراء خدمات الترويج للإعلانات",
				"registerCourses": "تسجيل دورات أو أحداث تخصصية"
			},
			"sellerUser": {
				"registerEquipmentAds": "تسجيل إعلانات بيع المعدات الجديدة والمستعملة",
				"registerMaterialAds": "تسجيل إعلانات بيع المواد",
				"registerAuctionAds": "تسجيل إعلانات مزاد المعدات",
				"manageAds": "إدارة الإعلانات",
				"receiveMessages": "استلام الرسائل",
				"viewStats": "مشاهدة الإحصائيات",
				"purchaseServices": "شراء سلم / فوري / خاص"
			}
		},
		"draftSaved": "تم حفظ المسودة.",
		"submitSuccess": "تم إرسال طلبك بنجاح وسيتم مراجعته بعد التحقق من قبل فريق Beauty Boss.",
		"saveError": "فشل حفظ الطلب.",
		"uploadError": "فشل تحميل الملف.",
		"shahkarFailed": "فشل التحقق من الرقم القومي. يرجى التحقق من رقمك القومي ورقم الجوال في ملفك الشخصي."
	},
	"chat": {
		"title": "الرسائل",
		"inbox": "صندوق الرسائل",
		"conversation": "محادثة",
		"send": "إرسال",
		"placeholder": "اكتب رسالة..."
	},
	"optimus": {
		"startsWith": "يبدأ بـ",
		"contains": "يحتوي على",
		"notContains": "لا يحتوي على",
		"endsWith": "ينتهي بـ",
		"equals": "يساوي",
		"notEquals": "لا يساوي",
		"noFilter": "بدون تصفية",
		"lt": "أقل من",
		"lte": "أقل من أو يساوي",
		"gt": "أكبر من",
		"gte": "أكبر من أو يساوي",
		"is": "هو",
		"isNot": "ليس",
		"before": "قبل",
		"after": "بعد",
		"dateIs": "التاريخ هو",
		"dateIsNot": "التاريخ ليس",
		"dateBefore": "التاريخ قبل",
		"dateAfter": "التاريخ بعد",
		"clear": "مسح",
		"apply": "تطبيق",
		"matchAll": "مطابقة الكل",
		"matchAny": "مطابقة أي",
		"addRule": "إضافة قاعدة",
		"removeRule": "إزالة القاعدة",
		"accept": "نعم",
		"reject": "لا",
		"choose": "اختر",
		"upload": "تحميل",
		"cancel": "إلغاء",
		"completed": "مكتمل",
		"fileSizeTypes": [
			"بايت",
			"كيلوبايت",
			"ميجابايت",
			"جيجابايت",
			"تيرابايت"
		],
		"dayNames": [
			"الأحد",
			"الاثنين",
			"الثلاثاء",
			"الأربعاء",
			"الخميس",
			"الجمعة",
			"السبت"
		],
		"dayNamesShort": [
			"أحد",
			"اثنين",
			"ثلاثاء",
			"أربعاء",
			"خميس",
			"جمعة",
			"سبت"
		],
		"dayNamesMin": [
			"أح",
			"إث",
			"ثلا",
			"أر",
			"خم",
			"جم",
			"سب"
		],
		"monthNames": [
			"يناير",
			"فبراير",
			"مارس",
			"أبريل",
			"مايو",
			"يونيو",
			"يوليو",
			"أغسطس",
			"سبتمبر",
			"أكتوبر",
			"نوفمبر",
			"ديسمبر"
		],
		"monthNamesShort": [
			"ينا",
			"فبر",
			"مار",
			"أبر",
			"ماي",
			"يون",
			"يول",
			"أغس",
			"سبت",
			"أكت",
			"نوف",
			"ديس"
		],
		"dateFormat": "mm/dd/yy",
		"firstDayOfWeek": 6,
		"today": "اليوم",
		"weekHeader": "أسبوع",
		"weak": "ضعيف",
		"medium": "متوسط",
		"strong": "قوي",
		"passwordPrompt": "أدخل كلمة المرور",
		"emptyMessage": "لا توجد نتائج",
		"emptyFilterMessage": "لا توجد نتائج",
		"emptySearchMessage": "لا توجد نتائج",
		"emptySelectionMessage": "لا يوجد عنصر محدد",
		"selectionMessage": "تم تحديد {0} عنصر",
		"searchMessage": "تتوفر {0} نتيجة",
		"fileChosenMessage": "تم اختيار {0} ملف",
		"noFileChosenMessage": "لم يتم اختيار أي ملف",
		"pending": "قيد الانتظار",
		"chooseYear": "اختر السنة",
		"chooseMonth": "اختر الشهر",
		"chooseDate": "اختر التاريخ",
		"prevDecade": "العقد السابق",
		"nextDecade": "العقد التالي",
		"prevYear": "السنة السابقة",
		"nextYear": "السنة التالية",
		"prevMonth": "الشهر السابق",
		"nextMonth": "الشهر التالي",
		"prevHour": "الساعة السابقة",
		"nextHour": "الساعة التالية",
		"prevMinute": "الدقيقة السابقة",
		"nextMinute": "الدقيقة التالية",
		"prevSecond": "الثانية السابقة",
		"nextSecond": "الثانية التالية",
		"am": "ص",
		"pm": "م",
		"aria": {
			"trueLabel": "صح",
			"falseLabel": "خطأ",
			"nullLabel": "غير محدد",
			"star": "{star} نجمة",
			"stars": "{star} نجوم",
			"selectAll": "تحديد كل العناصر",
			"unselectAll": "إلغاء تحديد كل العناصر",
			"close": "إغلاق",
			"previous": "السابق",
			"next": "التالي",
			"navigation": "التنقل",
			"scrollTop": "التمرير إلى الأعلى",
			"moveTop": "نقل إلى الأعلى",
			"moveUp": "نقل لأعلى",
			"moveDown": "نقل لأسفل",
			"moveBottom": "نقل إلى الأسفل",
			"moveToTarget": "نقل إلى الهدف",
			"moveToSource": "نقل إلى المصدر",
			"moveAllToTarget": "نقل الكل إلى الهدف",
			"moveAllToSource": "نقل الكل إلى المصدر",
			"pageLabel": "صفحة {page}",
			"firstPageLabel": "الصفحة الأولى",
			"lastPageLabel": "الصفحة الأخيرة",
			"nextPageLabel": "الصفحة التالية",
			"prevPageLabel": "الصفحة السابقة",
			"previousPageLabel": "الصفحة السابقة",
			"rowsPerPageLabel": "عدد الصفوف في الصفحة",
			"jumpToPageDropdownLabel": "الانتقال إلى الصفحة",
			"jumpToPageInputLabel": "الانتقال إلى الصفحة",
			"selectRow": "تحديد الصف",
			"unselectRow": "إلغاء تحديد الصف",
			"expandRow": "توسيع الصف",
			"collapseRow": "طي الصف",
			"showFilterMenu": "إظهار قائمة التصفية",
			"hideFilterMenu": "إخفاء قائمة التصفية",
			"filterOperator": "عامل التصفية",
			"filterConstraint": "قيد التصفية",
			"editRow": "تحرير الصف",
			"saveEdit": "حفظ التحرير",
			"cancelEdit": "إلغاء التحرير",
			"listView": "عرض القائمة",
			"gridView": "عرض الشبكة",
			"slide": "شريحة",
			"slideNumber": "شريحة {slideNumber}",
			"zoomImage": "تكبير الصورة",
			"zoomIn": "تكبير",
			"zoomOut": "تصغير",
			"rotateRight": "تدوير لليمين",
			"rotateLeft": "تدوير لليسار",
			"listLabel": "قائمة الخيارات",
			"selectColor": "اختر لونًا",
			"removeLabel": "إزالة",
			"browseFiles": "استعراض الملفات",
			"maximizeLabel": "تكبير",
			"minimizeLabel": "تصغير"
		}
	}
}
